import { Page, View } from "@react-pdf/renderer";
import Footer from "./Footer";
import TopMargin from "./TopMargin";

type PageLayoutProps = {
  children?: React.ReactNode;
};

const PageLayout: React.FC<PageLayoutProps> = (props) => {
  const { children } = props;

  return (
    <Page style={{ paddingBottom: 80 }}>
      {/* Subpages don't have a header */}
      <View fixed render={({ subPageNumber }) => subPageNumber > 1 && <TopMargin />} />

      {children}

      <Footer />
    </Page>
  );
};

export default PageLayout;
